class BAdmin {
  constructor({
    user: {
      pk,
      first_name,
      last_name,
      email,
      phone,
      country_code,
      profile_image
    },
    ...data
  }) {
    this.pk = data.pk;
    this.userPk = pk;
    this.firstName = first_name;
    this.lastName = last_name;
    this.name = this.firstName + ' ' + this.lastName;
    this.isActive = data.is_active;
    this.email = email;
    this.phone = phone?.length > 0 ? {
      dialCode: phone?.split(' ')[0].replace('+', ''),
      number: phone?.replace(/\s/g, '').replace(`+`, '').replace('-', ''),
      countryCode: country_code?.toLowerCase(),
      phone: phone
    } : {
      dialCode: '91',
      number: '91',
      countryCode: country_code,
      phone: ''
    };
    this.phoneLabel = this.phone?.phone?.replace(/^\+[0-9]{1,3}(\s|-)/, '');
    this.groupBy = data.roles[0];
    this.profileImage = profile_image;
  }
}
export default BAdmin;